import { render, staticRenderFns } from "./ClearTag.vue?vue&type=template&id=8a24e838&scoped=true"
import script from "./ClearTag.vue?vue&type=script&lang=js"
export * from "./ClearTag.vue?vue&type=script&lang=js"
import style0 from "./ClearTag.vue?vue&type=style&index=0&id=8a24e838&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a24e838",
  null
  
)

export default component.exports